import React from "react";
import useTranslation from "next-translate/useTranslation";
import styles from "./Popup.module.css";
import Medal from "../../../components/Medal";

import { getModeIcon, getModeNameCapitalFirst } from "../../../util/util";
// import { useLeagues } from "../../../ducks/leagues";
import { LeagueResult, ModeIds } from "@chesshotel/constants";
import { useSize } from "../../../hooks/useSize";

interface Props {
  leagueResult: LeagueResult;
  rank: number;
  leagueName: string;
  modeId: ModeIds;
}

export default function NewLeague(props: Props) {
  const { leagueResult, rank, leagueName, modeId } = props;
  const isDesktop = useSize();

  const { t } = useTranslation("common");

  return (
    <div className="flex items-center  pt-8 pb-11">
      <div className="flex flex-col items-center mr-3 md:mr-6">
        <Medal
          rank={rank}
          title="RANK"
          leagueName={leagueName}
          size={isDesktop ? "large" : "medium"}
        />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.leagueTitle}>{t("CONGRATULATIONS")}</div>
        <div className={styles.pointsRow}>
          <div className={styles.pointsCont}>
            <div
              className="flex flex-shrink-0 items-center justify-center
                w-10 h-10 rounded-full bg-altgray-100 text-xl text-red-500 mr-3"
            >
              {getModeIcon(modeId)}
            </div>
            <div className={styles.scoreCont}>
              <div className={styles.score}>
                {leagueResult === LeagueResult.ENTER_LEAGUE
                  ? t("You have entered")
                  : t("You are promoted to")}
              </div>
              <div className={`uppercase ${styles.scoreTitle}`}>
                {getModeNameCapitalFirst(modeId, t)}{" "}
                {t(leagueName + " league").toUpperCase()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
